import React from 'react';
import { Box, Grid, Button } from '@mui/material';
import { useSelector } from 'react-redux'
import { isLoaded, useFirestoreConnect } from 'react-redux-firebase'
import Loading from '../../shared/components/Loading'
import ShippingCard from './ShippingCard'
import ArrivalModel from './ArrivalModel';
import useToggle from './../../shared/functions/useToggle';


const Shipping = () => {
    const [isLoading, setLoading] = React.useState(false);
    const { open, handleOpen, handleClose } = useToggle();

    useFirestoreConnect(()=>[
        {collection:"shipping_orders", where:[["ActivityStatus", "!=", "Closed"]], limit:'100',  storeAs:"shippingsL"}
    ])

    const shippings = useSelector(state => state.firestore.ordered["shippingsL"])

    React.useEffect(()=> {
        if(!isLoaded(shippings)){
            setLoading(true)
        }else{
            setLoading(false)
        }
    },[shippings]);

    

    return (
       <>
           {!isLoading && 
            <Box sx={{m: 2, display :'flex', justifyContent:'flex-end' }}>
                <Button 
                    onClick={handleOpen} 
                    variant="contained" 
                    color="warning"> 
                    Select Shipping To Arrivals 
                </Button>
            </Box> }

         <Grid container spacing={2} justifyContent="center">
           {isLoading ? <Loading /> :
           shippings && shippings.map((shp)=>{

            return <Grid item key={shp.id}> <ShippingCard shipping={shp}/> </Grid>
           })} 
        </Grid>
       {open && <ArrivalModel open={open} onClose={handleClose} shippings={shippings} />}
       </>
    )
}

export default Shipping
